import { z } from "zod";

//const plans = ["free", "basic", "medium", "pro"];

/*export const mappedPlans = Object.fromEntries(
  plans.map(plan => [
    plan,
    plan.charAt(0).toUpperCase() + plan.slice(1)
  ])
);*/

export const userSchema = z.object({
  username: z
    .string()
    .min(3, {
      message: "El nombre de usuario debe tener al menos 3 caracteres.",
    })
    .max(200, {
      message: "El nombre de usuario debe tener menos de 200 caracteres.",
    }),
  email: z.string().email({
    message: "Por favor, introduzca un correo electrónico válido",
  }),
  password: z.string().min(6, {
    message: "La contraseña debe tener al menos 6 caracteres.",
  }),
  confirmPassword: z.string().min(6, {
    message: "La contraseña debe tener al menos 6 caracteres.",
  }),
}).refine(data => data.password === data.confirmPassword, {
    message: "Contraseñas no coinciden",
    path: ["confirmPassword"]
});


// validations/userSchema.js (TEMPORALMENTE SIMPLIFICADO)
/*import { z } from "zod";

export const userSchema = z.object({
    //username: z.string(),
    username: z.string().min(3, { message: "Usuario debe tener al menos 3 caracteres" }), // Validación MUY SIMPLE para username
});*/